import { AxiosError } from 'axios';

import { Environment } from './../../../../environment';

export const errorInterceptor = (error: AxiosError) => {
  const { data } = error.response || { data: undefined };

  if (error.response?.status === 401) {
    // window.location.href = `${Environment.BASE_URL}/SignIn?callback_url=${window.location.href}`;
  }

  if (error.message === 'Network Error') {
    return Promise.reject({ ...error, message: 'Erro de conexão.' });
  }

  if (data) {
    return Promise.reject(error);
  }

  return Promise.reject(error);
};
